import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://static.readdy.ai/image/0bfa0af67c6b6be26198661c1a60759c/3d8ce18578c897b8381251a25aef549c.jpeg";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Gallery", href: "#gallery" },
  { label: "Testimonials", href: "#testimonials" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#hero" onClick={() => handleNavClick("#hero")} className="flex items-center gap-3 cursor-pointer">
          <div className="h-12 w-32 overflow-hidden flex items-center">
            <img src={LOGO_URL} alt="ZoroBabel Cleaning Services Logo" className="h-full w-full object-contain object-left" />
          </div>
        </a>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <button
                onClick={() => handleNavClick(link.href)}
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-gray-600 hover:text-teal-600" : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick("#booking")}
            className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Book Now
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-gray-800" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick("#booking")}
            className="bg-teal-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full w-full cursor-pointer whitespace-nowrap"
          >
            Book Now
          </button>
        </div>
      )}
    </header>
  );
}
